import React from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';
import * as API from 'modules/app/API';
import * as RecentHelper from 'modules/app/Recent';
import { connect } from 'react-redux';

const maxAmountOfItems = 10;

class Recent extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    addRecent(item) {
        let type = RecentHelper.getTypes().find(type => {
            return type.recentTypeCode === item.recentType
        });

        if (!type)
            return;

        item.location = type.urlPattern.replace(":id", item.entityKey);
        item.iconName = type.iconName;

        // Remove item if repeated
        let newList = this.state.recentList.filter(i => {
            if (!i)
                return null;

            return !(i.activityTitle === item.activityTitle && i.iconName === item.iconName && i.location === item.location);
        });

        // Add repeated to the top of the list
        newList.unshift(item);

        // If more than 10, truncate.
        newList = newList.slice(0, maxAmountOfItems);

        this.setState({ recentList: newList });
    }

    refreshRecentList(recentList) {
        this.setState({ recentList: recentList });
    }

    initialState() {
        return {
            isOpen: true,
            recentList: [],
            newRecent: null
        };
    }

    componentDidMount() {
        let me = this;

        // Search recent items on Database
        API.App.get('/query/getLatestRecents', null, {
            success: (r) => {
                let recentList = r.data.items.map((recent, key) => {
                    let type = RecentHelper.getTypes().find(type => {
                        return type.recentTypeCode === recent.recentType
                    });

                    if (type)
                        return {
                            location: type.urlPattern.replace(":id", recent.entityKey),
                            iconName: type.iconName,
                            activityTitle: recent.recentTitle,
                            id: recent.recentId
                        };

                    return null;
                });

                if (recentList)
                    me.refreshRecentList(recentList);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.newRecent === nextProps.newRecent)
            return;

        this.addRecent(nextProps.newRecent);
    }

    onClick = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }

    render() {
        const recentList = this.state.recentList.map((item, key) => {
            if (item)
                return (
                    <li key={key}><Link to={item.location}><Glyphicon glyph={item.iconName} /> {item.activityTitle}</Link></li>
                );

            return null;
        });

        return (
            <React.Fragment>
                <a onClick={this.onClick} style={{ cursor: "pointer" }}>
                    <Glyphicon glyph="time" />
                    <span>Recent Activity</span>
                    <span className="pull-right">
                        <Glyphicon glyph={this.state.isOpen ? "chevron-down" : "chevron-right"} />
                    </span>
                </a>
                <ul className="treeview-menu" style={this.state.isOpen ? { display: "block" } : { display: "none" }}>
                    {recentList}
                    <li style={{ textAlign: "right" }}><Link to="/recent">More...</Link></li>
                </ul>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        newRecent: state.Recent.recent
    }
}

const RecentContainer = connect(
    mapStateToProps
)(Recent)

export default RecentContainer;



// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/Recent.js